// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import VueRouter from 'vue-router'
import { EventBus } from './common/js/event-bus.js';
// import store from './vuex/store'
// import Vuex from 'vuex'
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
// import routes from './routes'
import axios from 'axios'
import 'lib-flexible'
Vue.config.devtools = true;
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)

// Vue.use(VueLazyload, {
//     error: '//tp-app.oss-cn-hangzhou.aliyuncs.com/website/loading.gif',
//     loading: '//tp-app.oss-cn-hangzhou.aliyuncs.com/website/loading.gif',
//     try: 2
// })

// Vue.use(ElementUI)
Vue.use(router)


Vue.config.productionTip = false
import { isMobile } from './common/js/ua'
import global from './assets/js/global.js'
Vue.prototype.GLOBAL = global

if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    console.log('移动端！')
} else {
    console.log('PC端！')
}

Vue.filter('imgsrc', val => {
    return global.imgPath + val
})
Vue.filter('compressPic', val => {
    return global.imgPath + val + '?x-oss-process=image/resize,p_50'
})

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',

})


// WEBPACK FOOTER //
// ./src/main.js